<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      自训课程
    </div>
    <div class="tab">
      <div class="tabLeft">
        <div class="tabBox"
             @click="tabIndex=2"
             :style="tabIndex==2?'background: #0B8586;color:#fff':''">
          <span>课程管理</span>
        </div>
        <div class="tabBox"
             @click="tabIndex=1"
             :style="tabIndex==1?'background: #0B8586;color:#fff':''">
          <span>上传课程</span>
        </div>
        <div class="tabBox"
             @click="tabIndex=3"
             :style="tabIndex==3?'background: #0B8586;color:#fff':''">
          <span>成员列表</span>
        </div>
        <!-- <div class="tabBox"
             @click="tabIndex=4"
             :style="tabIndex==4?'background: #0B8586;color:#fff':''">
          <span>学习情况</span>
        </div> -->
      </div>
      <div class="tabRight"
           style="cursor:pointer"
           v-show="tabIndex==1"
           @click="isAddRes=true">
        <img src="../../assets/img/icon/jia2.png"
             alt="">
        <span>新增</span>
      </div>
      <div class="tabRight"
           style="cursor:pointer"
           v-show="tabIndex==3">
        <img src="../../assets/img/icon/jia2.png"
             alt="">
        <span>添加</span>
      </div>
    </div>
    <upload v-if="tabIndex==1"
            :isAddRes="isAddRes"
            @openAddRes="isAddRes=true"
            @closeAddRes="isAddRes=false"></upload>
    <!-- <course v-if="tabIndex==2"
            @changeTabIndex="changeTabIndex"></course> -->
    <course v-if="tabIndex==2"></course>
    <number v-if="tabIndex==3"></number>
    <!-- <statistics v-if="tabIndex==4"></statistics> -->
  </div>
</template>
<script>
import upload from '../../components/usCourse/upload';
import course from '../../components/usCourse/course';
import number from '../../components/usCourse/number';
// import statistics from '../../components/usCourse/statistics';
export default {
  name: 'usUpdateProject',
  components: {
    upload,
    course,
    number,
    // statistics
  },
  data () {
    return {
      storeName: '',
      tabIndex: 2,
      isAddRes: false
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
  },
  methods: {
    // changeTabIndex (e) {
    //   this.tabIndex = e
    // }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tabLeft {
    display: flex;
}
.tabBox {
    margin-right: 10px;
    width: 116px;
    height: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    cursor: pointer;
}
.tabRight {
    display: flex;
    align-items: center;
}
.tabRight img {
    width: 17px;
    height: 17px;
    margin-right: 10px;
}
.tabRight span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
</style>
